import { Box, Link } from '@opendoor/bricks-next';
import type { EntryComponent } from 'cms/entries/entries';
import type { ILpComponentLinkList } from 'declarations/contentful';

import Container from './shared/Container';

const RenderLinkList = (entry: ILpComponentLinkList) => {
  const { fields, sys } = entry;
  const { locale } = sys;

  return (
    <Container py="$4" display="flex" alignItems="center">
      <Box
        tag="ul"
        padding="$0"
        role="list"
        flexDirection="row"
        borderRadius="$full"
        borderWidth="$0dot5x"
        borderStyle="solid"
        borderColor="$borderPrimary"
        $platform-web={{ display: 'inline-flex', listStyle: 'none', paddingInlineStart: 0 }}
        zIndex={3}
      >
        {fields.links?.map((link, idx) => (
          <Box tag="li" key={idx} $platform-web={{ display: 'inline-flex' }}>
            {locale !== 'es' && (
              <Link
                aria-label={`Go to page ${link.fields.text}`}
                analyticsName={`cosmos-landing-page-link-list-${fields.analyticsId || ''}-${
                  link.fields.text
                }`}
                backgroundColor={link.fields.active ? '$backgroundAccentBrand' : '$transparent'}
                color={link.fields.active ? '$contentInversePrimary' : '$contentAccentBrand'}
                href={link.fields.url}
                py="$2"
                px="$6"
                fontWeight="$medium"
                borderRadius="$full"
                variant={link.fields.active ? 'secondaryInverse' : 'primary'}
                $platform-web={{ textDecorationLine: 'none' }}
              >
                {link.fields.text}
              </Link>
            )}
          </Box>
        ))}
      </Box>
    </Container>
  );
};

const LinkList: EntryComponent<ILpComponentLinkList> = {
  render: RenderLinkList,
};

export default LinkList;
